<template>
  <div class="marketplace_registration_header" id="applicationsHeader">
    <div class="header_bg_wrapper desktop_img">
      <div class="header_bg_text">
        Vivense'de Taşıyıcı Olun,<br />İşinizi Hızla Büyütün
      </div>
    </div>
    <div class="header_bg_wrapper mobile_img" style="display: none">
      <div class="header_bg_text">
        Vivense'de Taşıyıcı Olun,<br />İşinizi Hızla Büyütün
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplicationsCarrierHeader',
};
</script>
